import { memo, Suspense } from 'react';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material';
import Footer from '../footer';


const StyledBox = styled(Box)(() => ({
    transition: '0.3s ease-in-out',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: "#F1F1F1",
    minHeight: '100vh'
}));

const NormalChildLayout = memo(() => {
    return (
        <StyledBox key="layout" sx={{ paddingX: { xs: "10px", md: "40px" }, }} >
            <Box
                sx={{
                    display: "flex", flexDirection: "column",
                    gap: { xs: "20px", md: "30px" },
                    paddingY: { xs: "10px", md: "40px" },
                    flexGrow: 1,
                }}
            >
                <Suspense fallback={null}>
                    <Outlet />
                </Suspense>
            </Box>
            <Footer key="footer" />
        </StyledBox>
    );
});

export default NormalChildLayout;